export default __webpack_public_path__ + "static/media/Permanent.3f39c500.svg";